"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function Footer(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("footer", {
    className: "footer mt-auto py-3 bg-light",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "text-muted",
        children: "Place sticky footer content here."
      })
    })
  });
}
var _default = exports.default = Footer;
module.exports = exports.default;